import {useTranslation} from "react-i18next";
import ReactDOM from 'react-dom/client';

import {Link as LinkScroll, animateScroll as scroll, scroller} from "react-scroll";

import React, {useState, useEffect, useRef} from 'react';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    useLocation
} from "react-router-dom";
import {separatorNumber} from "../../../global/constants";


const CartCounter = ({userInfo, data, payType, shipFee = 0}) => {
    const {t, i18n} = useTranslation();
    const location = useLocation();
    const query = new URLSearchParams(location.search);

    const numericShipFee = Number(shipFee);
    const creditFee = (payType === 0) ? Math.round((data.totalPrice + numericShipFee) * 0.03) : 0;

    return <div className="text-black7 font-bold ">


        <div className="text-sm">
            <p className="">不折扣商品 NT$ {separatorNumber(data.originalProductPrice)}</p>
            {userInfo && userInfo.shoppingPoints > 0 && <>
                <p className="text-black7">購物金商品折抵 NT$ {separatorNumber(userInfo.shoppingPoints)}</p>
                <p className="">小計 NT$ {separatorNumber(data.totalOriginalProductPrice)}</p>
            </>}

            {
                userInfo && data.discountProductPrice != 0 ? (
                    <>
                        <p className={`mt-4 ${data.discountRatio != 0 ? "line-through text-black7" : "text-black7"}`}>
                            折扣商品 NT$ {separatorNumber(data.discountProductPrice)}
                        </p>
                        {data.discountRatio === 100 ? (
                            <p className="text-black7">一般會員無折扣</p>
                        ) : (
                            <p className="text-black7">
                                {t(`grade.${userInfo.identity.name}`)}折扣 {Number(data.discountRatio) / 10}折
                            </p>
                        )}
                        <p className="">折扣後 NT$ {separatorNumber(data.totalDiscountProductPrice)}</p>
                    </>
                ) : (
                    <p className="mt-4">折扣商品 NT$ {separatorNumber(data.discountProductPrice)}</p>
                )
            }
            <p className="">運費 NT$ {separatorNumber(numericShipFee)}</p>

            {
                payType === 0 ? (
                    <p className="">刷卡手續費 NT$ {separatorNumber(creditFee)}</p>
                ) : ""
            }


        </div>

        <p className="text-red1 font-bold mt-4">總計 NT$ {separatorNumber(data.totalPrice + numericShipFee + creditFee)}</p>

    </div>

}


export default CartCounter

